import React, { useState } from 'react';
import { Plus, Trash2 } from 'lucide-react';
import { toast } from 'sonner';
import { EditorShell, inputCls, labelCls } from './EditorShell';
import { useContent } from '../../context/ContentContext';
import { formatApiError } from '../../lib/api';

const ICONS = [['ticket', 'Billett'], ['bed', 'Seng'], ['music', 'Musikk'], ['star', 'Stjerne'], ['utensils', 'Mat']];

export const PricingEditor = ({ initial, onClose }) => {
  const { saveContent } = useContent();
  const [v, setV] = useState(initial);
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setV({ ...v, [k]: e.target.value });
  const setCard = (i, k, val) => setV({ ...v, cards: v.cards.map((c, j) => (j === i ? { ...c, [k]: val } : c)) });

  const save = async () => {
    setSaving(true);
    try { await saveContent('pricing', { ...v, cards: v.cards.filter((c) => c.title) }); toast.success('Lagra!'); onClose(); }
    catch (e) { toast.error(formatApiError(e)); }
    finally { setSaving(false); }
  };

  return (
    <EditorShell title="Rediger påmeldingsseksjonen" onClose={onClose} onSave={save} saving={saving} testId="pricing-editor">
      <div className="grid md:grid-cols-2 gap-4">
        <div><label className={labelCls}>Liten tekst over</label><input data-testid="pe-kicker" className={inputCls} value={v.kicker} onChange={set('kicker')} /></div>
        <div><label className={labelCls}>Overskrift</label><input data-testid="pe-heading" className={inputCls} value={v.heading} onChange={set('heading')} /></div>
      </div>
      <div><label className={labelCls}>Ingress</label><textarea className={`${inputCls} resize-y`} rows={2} value={v.intro} onChange={set('intro')} /></div>
      <div>
        <div className="flex items-center justify-between mb-2">
          <label className={labelCls}>Boksar ({v.cards.length})</label>
          {v.cards.length < 6 && <button type="button" data-testid="pe-add-card" onClick={() => setV({ ...v, cards: [...v.cards, { id: `c${Date.now()}`, icon: 'star', title: '', price: '', desc: '' }] })} className="inline-flex items-center gap-1 text-xs font-bold text-[#ff2e2e] hover:underline"><Plus size={14} /> Legg til boks</button>}
        </div>
        <div className="space-y-3">
          {v.cards.map((c, i) => (
            <div key={c.id} className="rounded-2xl border border-white/10 p-4 grid md:grid-cols-[1fr_120px_130px_auto] gap-3" data-testid={`pe-card-${i}`}>
              <input className={inputCls} placeholder="Tittel" value={c.title} onChange={(e) => setCard(i, 'title', e.target.value)} data-testid={`pe-card-title-${i}`} />
              <input className={inputCls} placeholder="Pris" value={c.price} onChange={(e) => setCard(i, 'price', e.target.value)} />
              <select className={inputCls} value={c.icon} onChange={(e) => setCard(i, 'icon', e.target.value)}>{ICONS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select>
              <button type="button" onClick={() => setV({ ...v, cards: v.cards.filter((_, j) => j !== i) })} aria-label="Fjern boks" data-testid={`pe-card-remove-${i}`} className="w-12 h-12 rounded-2xl border border-white/10 text-white/50 hover:text-red-400 hover:border-red-500 flex items-center justify-center"><Trash2 size={16} /></button>
              <textarea className={`${inputCls} md:col-span-4 resize-y`} rows={2} placeholder="Skildring" value={c.desc} onChange={(e) => setCard(i, 'desc', e.target.value)} />
            </div>
          ))}
        </div>
      </div>
      <div><label className={labelCls}>Merknad under boksane</label><textarea className={`${inputCls} resize-y`} rows={2} value={v.note} onChange={set('note')} /></div>
      <div className="grid md:grid-cols-2 gap-4">
        <div><label className={labelCls}>Hovudknapp</label><input className={inputCls} value={v.primary} onChange={set('primary')} /></div>
        <div><label className={labelCls}>Sekundærknapp (tom = skjul)</label><input className={inputCls} value={v.secondary} onChange={set('secondary')} /></div>
      </div>
    </EditorShell>
  );
};
